import {Box} from "@mui/material"
import useResponsive from "../../hooks/useResponsive"
import {HEADER} from "../../config-global"

const SPACING = 8

export default function Main({children, sx, ...other}) {
    const isDesktop = useResponsive("up", "lg")

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                py: `${HEADER.H_MOBILE + SPACING}px`,
                ...(isDesktop && {
                    px: 2,
                    py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
                    width: 1
                }),
                ...sx
            }}
            {...other}
        >
            {children}
        </Box>
    )
}